export const setCacheExp = (minutes = 5) =>
  new Date().getTime() + minutes * 60000;
